export enum POSITION {
    north = 'n',
    south = 's',
    east = 'e',
    west = 'w',
    northEast = 'ne',
    northWest = 'nw',
    southEast = 'se',
    southWest = 'sw'
}

export interface HANDLE_RESIZE_PROPS {
    /**
     * If true, it triggers the dragend event.
     */
    end: boolean;
    /**
     * Position of the drag element. There can be one of the enum `POSITION` values.
     */
    pos: POSITION;
}

export interface RESIZER_PROPS {
    onResize: (e: any, args: HANDLE_RESIZE_PROPS) => void;
    positions?: POSITION[];
}

export interface DISPATCHER_BASE_GRID_PROPS {
    columns: any[],
    data: any[],
    style?: any,
    rowHeight?: number,
    className?: string,
    text?: string,
    moduleContentText?: string,
    rowRender?: any
}
